import { Component, OnInit } from '@angular/core';
import { SupportService } from './support.service';
import { colors, AuthorizationSchemeService, AuthorizationScheme } from '@mango/core';
import { HttpClient } from '@angular/common/http';
import { interval, Observable, Subscription } from 'rxjs';
import { ThrowStmt } from '@angular/compiler';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

import packageInfo from 'package.json';

@Component({
    selector: 'support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {
    myScheme: AuthorizationScheme;
    
    browserName:string;
    osName: string;
    osVersion:string;
    mobile:string;
    browser:string;
    version:string;
    majorversion:string;
    quoteText:string;
    userAgent:string;
    DocumentFolder:string;

    MiLabProName: string;
    MiLabProVersion: string;
    MiLabProDate: string;

    currentImage = 1;
    maxImage = 11;

    constructor(private service: SupportService, private authService: AuthorizationSchemeService, private http:HttpClient, private router: Router ) {
        this.myScheme = this.authService.getMyScheme();

    }

    private updateSubscription: Subscription;

    ngOnInit() {

        this.browserName = this.getBrowserVersion();
        this.DocumentFolder = environment.DocumentFolder;

        this.MiLabProVersion = packageInfo.version;
        this.MiLabProDate = packageInfo.date;
        this.MiLabProName = packageInfo.application;
        
        this.getInfo();        
        this.randomQuotes();
        
        if (this.MiLabProName != environment.ApplicationName)
        {   // When Test
            this.MiLabProName = environment.ApplicationName;
        }
        
        // Then Auto refresh quote every 1 minute!
        this.updateSubscription = interval(60000).subscribe(
            (val) => { 
                this.randomQuotes();                        
            });
    }

    nextImage() {
        this.currentImage++;

        if (this.currentImage > this.maxImage) {
            this.currentImage = 1;
        }
    }

    currentImageSrc() {
        return `/assets/${this.currentImage}.jpg`;
    }

    getBrowserVersion(){
  
        var userAgent= navigator.userAgent, tem, 
          matchTest= userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  
        if(/trident/i.test(matchTest[1])){
              tem=  /\brv[ :]+(\d+)/g.exec(userAgent) || [];
              return 'IE '+(tem[1] || '');
        }
  
        if(matchTest[1]=== 'Chrome'){
             tem= userAgent.match(/\b(OPR|Edge)\/(\d+)/);
              if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
  
        matchTest= matchTest[2]? [matchTest[1], matchTest[2]]: [navigator.appName, navigator.appVersion, '-?'];
  
        if((tem= userAgent.match(/version\/(\d+)/i))!= null) matchTest.splice(1, 1, tem[1]);
  
        return matchTest.join(' ');
  
    }
     
    getInfo() {
        {
            var unknown = 'Unknown';
   
            //browser
            var nVer = navigator.appVersion;
            var nAgt = navigator.userAgent;
            var browser = navigator.appName;
            var version = '' + parseFloat(navigator.appVersion);
            var majorVersion = parseInt(navigator.appVersion, 10);
            var nameOffset, verOffset, ix;            
    
            // Opera
            if ((verOffset = nAgt.indexOf('Opera')) != -1) {
                browser = 'Opera';
                version = nAgt.substring(verOffset + 6);
                if ((verOffset = nAgt.indexOf('Version')) != -1) {
                    version = nAgt.substring(verOffset + 8);
                }
            }
            // MSIE
            else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
                browser = 'Microsoft Internet Explorer';
                version = nAgt.substring(verOffset + 5);
            }
    
            //IE 11 no longer identifies itself as MS IE, so trap it
            //http://stackoverflow.com/questions/17907445/how-to-detect-ie11
            else if ((browser == 'Netscape') && (nAgt.indexOf('Trident/') != -1)) {
    
                browser = 'Microsoft Internet Explorer';
                version = nAgt.substring(verOffset + 5);
                if ((verOffset = nAgt.indexOf('rv:')) != -1) {
                    version = nAgt.substring(verOffset + 3);
                }
    
            }
    
            // Edge
            else if ((verOffset = nAgt.indexOf('Edg')) != -1) {
                browser = 'Edge/Chrome';
                version = nAgt.substring(verOffset + 4);
            }
            // Chrome
            else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
                browser = 'Chrome';
                version = nAgt.substring(verOffset + 7);
            }
            // Safari
            else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
                browser = 'Safari';
                version = nAgt.substring(verOffset + 7);
                if ((verOffset = nAgt.indexOf('Version')) != -1) {
                    version = nAgt.substring(verOffset + 8);
                }
    
                // Chrome on iPad identifies itself as Safari. Actual results do not match what Google claims
                //  at: https://developers.google.com/chrome/mobile/docs/user-agent?hl=ja
                //  No mention of chrome in the user agent string. However it does mention CriOS, which presumably
                //  can be keyed on to detect it.
                if (nAgt.indexOf('CriOS') != -1) {
                    //Chrome on iPad spoofing Safari...correct it.
                    browser = 'Chrome';
                    //Don't believe there is a way to grab the accurate version number, so leaving that for now.
                }
            }
            // Firefox
            else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
                browser = 'Firefox';
                version = nAgt.substring(verOffset + 8);
            }
            // Other browsers
            else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
                browser = nAgt.substring(nameOffset, verOffset);
                version = nAgt.substring(verOffset + 1);
                if (browser.toLowerCase() == browser.toUpperCase()) {
                    browser = navigator.appName;
                }
            }
            // trim the version string
            if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
            if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
            if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);
    
            majorVersion = parseInt('' + version, 10);
            if (isNaN(majorVersion)) {
                version = '' + parseFloat(navigator.appVersion);
                majorVersion = parseInt(navigator.appVersion, 10);
            }
    
            // mobile version
            var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);
   
            // system
            var os = unknown;
            var clientStrings = [
                {s:'Windows 3.11', r:/Win16/},
                {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
                {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
                {s:'Windows 98', r:/(Windows 98|Win98)/},
                {s:'Windows CE', r:/Windows CE/},
                {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
                {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
                {s:'Windows Server 2003', r:/Windows NT 5.2/},
                {s:'Windows Vista', r:/Windows NT 6.0/},
                {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
                {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
                {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
                {s:'Windows 10', r:/(Windows 10|Windows NT 10.0)/},
                {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
                {s:'Windows ME', r:/Windows ME/},
                {s:'Android', r:/Android/},
                {s:'Open BSD', r:/OpenBSD/},
                {s:'Sun OS', r:/SunOS/},
                {s:'Linux', r:/(Linux|X11)/},
                {s:'iOS', r:/(iPhone|iPad|iPod)/},
                {s:'Mac OS X', r:/Mac OS X/},
                {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
                {s:'QNX', r:/QNX/},
                {s:'UNIX', r:/UNIX/},
                {s:'BeOS', r:/BeOS/},
                {s:'OS/2', r:/OS\/2/},
                {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
            ];
            for (var id in clientStrings) {
                var cs = clientStrings[id];
                if (cs.r.test(nAgt)) {
                    os = cs.s;
                    break;
                }
            }
    
            var osVersion = unknown;
    
            if (/Windows/.test(os)) {
                osVersion = /Windows (.*)/.exec(os)[1];
                os = 'Windows';
            }
    
            switch (os) {
                case 'Mac OS X':
                    osVersion = /Mac OS X (10[\.\_\d]+)/.exec(nAgt)[1];
                    break;
    
                case 'Android':
                    osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
                    break;
    
                case 'iOS':
                    osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer)[1];
                    osVersion = osVersion[1] + '.' + osVersion[2] + '.' + osVersion[3];
                    break;
    
            }

            if (navigator.userAgent == "Mi-Lab-Pro") {

                this.browserName = "Mi-Lab-Pro App";
                this.osName = "";
                this.osVersion = "";            
                this.browser="";
                this.version="";
                this.majorversion = "";
                this.userAgent = navigator.userAgent;

            } else {
                this.browserName = browser;
                this.osName = os;
                this.osVersion = osVersion;            
                this.browser=browser;
                this.version=version;
                this.majorversion = majorVersion.toString();
            }
            

        }
    }

    /* quotes */
    quotes = [
        'CIJ Borculo BV --Met 45 specialisten kalbreren en keuren we dagelijs voor opdrachtgevers in heel Nederland, op locatie en in ons laboratorium.',
        'Keuringen en controle --In Nederland is CIJ Borculo het enige bedrijf dat zowel gas-, warmte- als elektrameters op locatie kan keuren.',
        'Kwaliteit --Bij CIJ Borculo B.V. staat kwaliteit en veiligheid centraal in alles wat we doen. We zijn ISO/IEC 17025 geaccrediteerd en voldoen aan de strengste normen en wet- en regelgeving binnen onze sector.',
        'QR-Code --Altijd direct toegang tot certificaten en kalibratiegegevens. Geen papierwerk meer – alles digitaal en up-to-date.',
        'Shuttledienst --Wij halen uw instrument op, kalibreren het en brengen het verzekerd terug door onze eigen shuttledienst. Geen gedoe met verpakking of verzending en gegarandeerd een snelle doorloop.',
        'Kalibratie en Reparatie --Voldoet uw instrument niet meer? Wij repareren of justeren het snel en zorgvuldig. U ontvangt een certificaat vóór en na de reparatie, zodat u zeker weet dat alles weer klopt.',
        'Klantenportaal --Bekijk kalibratiehistorie, certificaten en herleidbaarheid in één oogopslag in Mi-Lab-Pro. Ideaal voor audits en efficiënt beheer van uw instrumenten.',
        'Ons motto staat altijd centraal --\'Zeker meten!\'',
        '1948 --In Borculo wordt de Centrale IJkinrichting voor Elekriciteitsmeters opgericht. CIJ reviseert en ijkt elektriciteitsmeters voor de Elektriciteitsmaatschappij De Berkelstreek',
        '1975 --CIJ breidt uit met een afdeling gespecialiseerd in meetintrumenten. Hiermee worden steeds meer klanten in allerlei sectoren bediend.',
        '1992 --CIJ Borculo B.V. wordt ISO/IEC 17025 geaccrediteerd. Hierdoor wordt de kwaliteit en precisie van CIJ Borculo onderschreven.',
        '2000 --CIJ Borculo B.V. krijgt officiële erkenningen voor het keuren van gasmeters, elektriciteitsmeters, EVHI\'s en het installeren van grootverbruikmeters.',
        '2006 --In dit jaar lanceerde CIJ Borculo zijn klantenportaal waarmee klanten eenvoudiger toegang kregen tot informatie over hun instrumenten en certificaten.',
        '2010 --CIJ Borculo B.V. defineert een nieuwe norm in de branche met zijn geavanceerde aanpak voor gasmetingen op locatie.',
        '2014 --Na het overweldigende succes van de gasmetingen op locatie volgt een nieuwe dienst : warmtemetingen op locatie.',
        '2021 --Scan de QR-code op het instrument en krijg direct toegang tot het certificaat, mogelijk gemaakt door het nieuwe klantenportaal.'
    ]

    randomQuotes() {
        var idx = Math.floor(Math.random() * this.quotes.length)
        this.quoteText = this.quotes[idx].replace("--","\n\n");
    }

    

}
